/** True when value is null, undefined, or ''. Unlike typical truthy checks, numeric 0 is not blank. */
export const isBlankValue = (value: unknown): boolean =>
  value === null || value === undefined || value === "";

/** True when the user entered a value (including 0). Inverse of isBlankValue. */
export const hasEnteredValue = (value: unknown): boolean => !isBlankValue(value);

/** Trim strings before empty/entered checks; non-strings unchanged. */
export const normalizeTrimmedValue = (value: unknown): unknown =>
  typeof value === "string" ? value.trim() : value;

export const hasEnteredTrimmedValue = (value: unknown): boolean =>
  hasEnteredValue(normalizeTrimmedValue(value));
